<script setup lang="js">
import LmoUrlService from '@/shared/services/lmo_url_service';
import EventBus from '@/shared/services/event_bus';
import AbilityService from '@/shared/services/ability_service';
import TopicTagsMenu from '@/components/tags/topic_tags_menu';
import { computed } from 'vue';

const { topicable, subpageTitle, subpageParentTo } = defineProps({
  topicable: Object,
  subpageTitle: String,
  subpageParentTo: String
});

const topic = computed(() => topicable.topic());
const topicTopicable = computed(() => topic.value.topicable());
const group = computed(() => topicable.group());
const groups = computed(() => {
  if (!group.value) { return []; }
  return group.value.parentsAndSelf().map(group => {
    return {
      title: group.name,
      disabled: false,
      to: group.id ? LmoUrlService.route({model: group}) : '/dashboard/direct_discussions'
    };
  });
});
const breadcrumbs = computed(() => {
  const items = groups.value.slice();
  if (subpageTitle) {
    items.push({
      title: topicable.title,
      disabled: false,
      to: subpageParentTo
    });
  } else if (topicable !== topicTopicable.value) {
    items.push({
      title: topicTopicable.value.title,
      disabled: false,
      to: LmoUrlService.route({model: topicTopicable.value})
    });
  }
  return items;
});
const tags = computed(() => topic.value.tags);
const isPinned = computed(() => !!topic.value.pinnedAt);
const canEditTags = computed(() => AbilityService.canEditTags(topic.value));

function titleVisible(visible) {
  EventBus.$emit('content-title-visible', visible);
}
</script>

<template lang="pug">
.topic-header
  .d-flex.flex-wrap.align-center.text-body-medium
    v-breadcrumbs.ml-n3.context-panel__breadcrumbs.flex-grow-1(color="anchor" :items="breadcrumbs")
      template(v-slot:divider)
        common-icon(name="mdi-chevron-right")
    tags-display(v-if="!subpageTitle" :tags="tags" :group="group")
    topic-tags-menu(v-if="!subpageTitle && canEditTags" :topic="topic")
  h1.text-headline-large.context-panel__heading#sequence-0.pt-2.mb-4(tabindex="-1" v-intersect="{handler: titleVisible}")
    span(v-if="subpageTitle") {{ subpageTitle }}
    plain-text(v-else :model='topicable' field='title')
    i.mdi.mdi-pin-outline.context-panel__heading-pin(v-if="isPinned && !subpageTitle")
</template>

<style>
.topic-header .v-breadcrumbs {
  padding: 4px 10px 4px 10px;
}
</style>
